module.exports = {
      id: "share-alt-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#share-alt",
      toString: function () {
        return this.url;
      }
    }